import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Application from "../types/application";
import http from "../api/http";
import { getCompany } from "./company";

interface ApplicationState {
  status: "idle" | "loading" | "failed";
  selectedApplication?: Application;
  enabledApplications: Application[];
}

const initialState: ApplicationState = {
  status: "idle",
  enabledApplications: [],
};

export const fetchApplication = createAsyncThunk<Application, number>(
  "apps/fetch",
  async (id: number) => {
    const response = await http.get<Application>(`/application/${id}`);
    return response.data;
  }
);

export const fetchApplicationList = createAsyncThunk<Application[]>(
  "apps/fetch-all",
  async () => {
    const response = await http.get<Application[]>("/application", {
      params: {
        refreshToken: true,
      },
    });
    return response.data;
  }
);

const applicationSlice = createSlice({
  name: "application",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplication.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchApplication.fulfilled, (state, action) => {
        state.status = "idle";
        state.selectedApplication = action.payload;
      })
      .addCase(fetchApplication.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(fetchApplicationList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchApplicationList.fulfilled, (state, action) => {
        state.status = "idle";
        state.enabledApplications = action.payload;
      })
      .addCase(fetchApplicationList.rejected, (state) => {
        state.status = "failed";
      })

      .addCase(getCompany.fulfilled, (state, action) => {
        if (!action.payload) {
          state.enabledApplications = initialState.enabledApplications;
          state.selectedApplication = initialState.selectedApplication;
        }
      });
  },
});

export default applicationSlice.reducer;
